var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-provider-error" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "email-provider-error__content" }, [
        _c(
          "span",
          {
            staticClass:
              "email-provider-error__title typographies-paragraph-large-semibold"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__("email.EmailProviderError.sync_error", {
                    userEmail: _vm.currentUserEmail
                  })
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "email-provider-error__description typographies-paragraph-medium-regular"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "email.EmailProviderError.sync_error_try_to_reconnect"
                  )
                ) +
                "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "email-provider-error__button",
        attrs: { label: _vm.$t.__("common.labels.access_settings") },
        on: {
          click: function($event) {
            return _vm.goToUrl("/settings/email")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "email-provider-error__footer" },
        [
          _c(
            "span",
            {
              staticClass:
                "email-provider-error__footer-text typographies-paragraph-medium-regular"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t.__("common.labels.if_problem_persists_please")
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassPlainButton", {
            attrs: { label: _vm.$t.__("common.labels.contact_support") },
            on: { click: _vm.handleContactSupport }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email-provider-error__illustration" }, [
      _c("img", {
        attrs: { src: "/ressources/logged/img/illustrations/sync-error.svg" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }